import { Route } from '@angular/router';
import { BesoinEditComponent } from './besoin-edit.component';

export const BesoinEditComponentRouting: Route = {
  path: "edit-besoin",
  component: BesoinEditComponent,
  data: {
    breadcrumb: "Gestion du besoin"
  }
}
